import { Component, Input, ViewChild, ElementRef } from "@angular/core";
import { Router } from "@angular/router";

import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent {
  constructor(private modalService: ModalService, private router: Router) {}
  @Input() lawyerName = "";
  @Input("nationalId") societyNationalId = "";
  @ViewChild("content") myModal: ElementRef;

  close() {
    this.modalService.close();
  }

  open() {
    this.modalService.open(this.myModal);
  }
}
